import Backend from "../Backend";

/**
 * Kontoverbund — Konten, auf die der angemeldete Benutzer wechseln darf.
 * Anders als die Admin-Impersonierung ergibt sich die Berechtigung hier aus
 * den konfigurierten User-Relationen, nicht aus dem Admin-Flag.
 */
class AccountData {
    static getMyAccounts() {
        return Backend.getData('/api/relations/me');
    }

    static switchAccount(targetUserId) {
        return Backend.postData(`/api/relations/switch/${targetUserId}`, {});
    }
}

export default AccountData;
